<app-loading [hidden]="load"></app-loading>

<section class="page-title page-title-layout3 text-center bg-overlay bg-parallax " style="background-size: cover; background-position: center center;">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <h1 class="pagetitle__heading mb-10">Publications</h1>
               
            </div>
        </div>
    </div>
</section>

<section class="portfolio-layout3">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-3">
                <ul class="portfolio-filter  justify-content-center list-unstyled" style="padding: 11px;">
                    <li [ngClass]="{'active2': selectedItem == null}" routerLink="/aboutUs"><a>All</a></li>
                    <li *ngFor="let item of arrayAboutUs" [ngClass]="{'active2': selectedItem == item.postID}">
                      <a style="cursor: pointer;" routerLink="/aboutUs/{{item.postID}}">{{item.postTitle}}</a>
                    </li>
                </ul>
            </div>

            <div class="row col-sm-12 col-md-12 col-lg-9" style="min-height: 400px;">

                <div class="col-sm-12 col-md-12 col-lg-12" *ngFor="let item of arrayAboutAll">
                    <div class="job-item">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <h1  class="job-item__title job-item__type" style="text-align: center; font-size: 20px;">{{item.postTitle}}</h1>
                                <p>{{item.postSubTitle}}</p>
                                <p class="pDetails"  [innerHTML]="item.postDetails"></p>
                       </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
